"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateValid = void 0;
var date_fns_1 = require("date-fns");
/**
 * Function to check if a date is valid. returns true or false
 *
 * @param checkDate
 * @param maximumDate
 * @param minimumDate
 * @param ignoreWeekends
 * @param ignoreDates
 */
var isDateValid = function (checkDate, maximumDate, minimumDate, ignoreWeekends, ignoreDates, dateFormat) {
    var isValidPassedDate = true;
    var curDateFormat = dateFormat ? dateFormat : 'dd/MM/yyyy';
    if (!(0, date_fns_1.isValid)(checkDate)) {
        /* istanbul ignore next */
        return false;
    }
    if (ignoreWeekends) {
        isValidPassedDate = !(0, date_fns_1.isWeekend)(checkDate);
    }
    if (ignoreDates && ignoreDates.length >= 1) {
        isValidPassedDate = isValidPassedDate && !ignoreDates.includes((0, date_fns_1.format)(checkDate, curDateFormat));
    }
    if (maximumDate) {
        isValidPassedDate = isValidPassedDate && (0, date_fns_1.isAfter)(maximumDate, checkDate);
    }
    if (minimumDate) {
        isValidPassedDate = isValidPassedDate && (0, date_fns_1.isBefore)(minimumDate, checkDate);
    }
    return isValidPassedDate;
};
exports.isDateValid = isDateValid;
